import { useEffect, useState } from 'react';

import cn from 'classnames';

import Column from '../../Blocks/Column';
import AnimateArrow from '../../Buttons/AnimateArrow';
import DropDown from '../../Elements/DropDown';
import ScrollBlock from '../../Elements/ScrollBlock';
import SelectLine from './SelectLine';
import styles from './styles.module.scss';

const keyHandlers = {
  38: 'handleUpKey',
  40: 'handleDownKey',
  32: 'handleSpaceKey',
  13: 'handleEnterKey',
  27: 'handleEscKey',
  74: 'handleDownKey',
  75: 'handleUpKey',
};

export default function Select({
  updateValue = false,
  list = [],
  small = false,
  big = false,
  width,
  select = '',
  fontSize,
  style,
  center,
  showLine = 8,
  preventState = false,
  placeholder = 'Выбрать вариант',
  label = '',
  greyLabel = false,
  disabled = false,
  valueFn = (v) => v,
  children,
  add = false,
  addText = 'Добавить',
  clickAdd = () => { },
  onSelect = () => {
    console.log('select value');
  },
  ...props
}) {
  const [isOpen, changeOpen] = useState(false);

  const [selected, changeSelect] = useState(select);
  const [focus, changeFocus] = useState(-1);

  function openDropDown() {
    changeOpen(true);
  }
  const closeDropDown = () => {
    changeOpen(false);
    changeFocus(-1);
  };

  const onClickSelect = (item, index) => {
    if (!preventState) {
      changeSelect(item);
    }
    onSelect(item, index);
    closeDropDown();
  };


  useEffect(() => {
    changeSelect(select);
  }, [select, updateValue]);

  const keyDown = (e) => {
    const code = e.keyCode;

    if (isOpen) {
      if (Object.keys(keyHandlers).includes(code.toString())) {
        e.preventDefault();
      }

      if (code === 13) {
        if (isOpen) {
          onClickSelect(list[focus], focus);
          closeDropDown();
        }
      }

      if (code === 27) {
        closeDropDown();
      }
      if (code === 40 || code === 38) {
        if (focus === -1) {
          changeFocus(0);
        }
        if (code === 40) {
          changeFocus(focus === list.length - 1 ? 0 : focus + 1);
        } else {
          changeFocus(focus === 0 ? list.length - 1 : focus - 1);
        }
      }
    }
  };

  return (
    <Column style={style}>
      {label.length > 0 && <span className={cn(styles.input_label, big && styles.input_label_big, greyLabel && styles.input_label_grey)}>{label}</span>}

      <div
        className={cn(styles.select, big && styles.select_big, small && styles.select_small, isOpen && styles.border_black, props.styles)}
        style={{ width, fontSize, ...props.style, ...(center && { justifyContent: 'center' }) }}
        id="drop-down"
        onKeyDown={keyDown}
        onClick={() => {
          if (isOpen) {
            closeDropDown();
          } else {
            openDropDown();
          }
        }}
      >
        <AnimateArrow
          isOpen={disabled ? (_) => _ : isOpen}
          styles={cn(styles.open_icon_arrow, small && styles.arrow_small, big && styles.arrow_big)}
        />
        {valueFn(selected) && valueFn(selected).toString().length > 0 ? (
          valueFn(selected)
        ) : (
          <span className={styles.placeholder}>{placeholder}</span>
        )}
        {isOpen && !disabled && (
          <DropDown
            styles={cn(styles.select_drop_down, small && styles.select_drop_down_small, big && styles.select_drop_down_big)}
            close={() => closeDropDown()}
          >
            <div>
              <ScrollBlock maxHeight={showLine * 38}>
                {list.map((item, key) => (
                  <SelectLine
                    key={key}
                    item={valueFn(item)}
                    disabled={typeof item === 'object' ? item.disabled : false}
                    focus={focus === key}
                    onMouseOver={() => changeFocus(key)}
                    onSelect={() => onClickSelect(item, key)}
                    small={small}
                    big={big}
                  />
                ))}
                {add && (
                  <SelectLine
                    item={addText}
                    focus={focus === list.length}
                    onMouseOver={() => changeFocus(list.length)}
                    onSelect={() => {
                      clickAdd();
                      console.log('close select');
                      closeDropDown();
                    }}
                    small={small}
                    big={big}
                  />
                )}
              </ScrollBlock>
            </div>
          </DropDown>
        )}
      </div>
    </Column>
  );
}
